import React from 'react';
import {useDispatch, useSelector} from 'react-redux'
import {CardGridActions} from './actions/CardGridAction'
import { Link } from 'react-router-dom';
import { ConditionalLink } from './components/formatters/conditionalLink';

const Header = () => {
  const cardData = useSelector(state => state.cardGrid)
  const dispatch = useDispatch()
  const handleSignOut = async () => {
    dispatch(CardGridActions.handleLogout())
  }

    return (
        <div className="ui fixed inverted menu">
        <div className="ui container">
          <Link onClick={handleSignOut} to={cardData.isUserLoggedIn ? '/' : '/mygrid'}> <button className="ui orange button">{cardData.isUserLoggedIn ? 'Sign Out' : 'Sign In'}</button></Link>
          <button className="ui orange button" style={{display: cardData.isUserLoggedIn ? 'block' : 'none' }}>
            {cardData.userName ? `Welcome ${cardData.userName}` : ''}
          </button>

          <Link to="/"  className="item">Home</Link>
          <Link to="/gallery"  className="item">Browse Gallery</Link>
          <Link to="/setView"  className="item">Complete Set Browse</Link>
          <ConditionalLink to="/mygrid"  condition={cardData.isUserLoggedIn} className="item">Manage your Collection</ConditionalLink>
          <ConditionalLink to="/checklistView" condition={cardData.isUserLoggedIn} className="item">Checklist View</ConditionalLink>
        </div>
      </div>
    )
}
export default Header